export const SmartphoneIcon: React.FC<React.SVGProps<SVGSVGElement>> = (
  props,
) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      {...props}
    >
      <g>
        <path
          d="M5.00004 0.833328H15C15.4421 0.833328 15.866 1.00892 16.1786 1.32148C16.4911 1.63404 16.6667 2.05797 16.6667 2.49999V17.5C16.6667 17.942 16.4911 18.3659 16.1786 18.6785C15.866 18.9911 15.4421 19.1667 15 19.1667H5.00004C4.55801 19.1667 4.13409 18.9911 3.82153 18.6785C3.50897 18.3659 3.33337 17.942 3.33337 17.5V2.49999C3.33337 2.05797 3.50897 1.63404 3.82153 1.32148C4.13409 1.00892 4.55801 0.833328 5.00004 0.833328Z"
          strokeWidth="1.67"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M9.99877 15.8342C9.99862 15.8339 9.99852 15.8336 9.99845 15.8333C9.99852 15.8331 9.99862 15.8328 9.99877 15.8324C9.99894 15.832 9.99906 15.8318 9.99907 15.8318C9.99909 15.8318 9.99901 15.8319 9.99878 15.8322C9.99857 15.8324 9.99844 15.8325 9.99844 15.8324C9.99844 15.8324 9.99862 15.8323 9.99905 15.8321C9.9994 15.832 9.99971 15.8319 9.99996 15.8318C10.0002 15.8319 10.0005 15.832 10.0009 15.8321C10.0009 15.8322 10.001 15.8322 10.0011 15.8322C10.0011 15.8323 10.0011 15.8324 10.0012 15.8324C10.0013 15.8328 10.0014 15.8331 10.0015 15.8333C10.0014 15.8336 10.0013 15.8339 10.0012 15.8342C10.001 15.8347 10.0009 15.8348 10.0008 15.8348C10.0008 15.8349 10.0009 15.8347 10.0011 15.8345C10.0013 15.8343 10.0015 15.8342 10.0015 15.8342C10.0015 15.8342 10.0013 15.8343 10.0009 15.8345C10.0005 15.8347 10.0002 15.8348 9.99996 15.8348C9.99971 15.8348 9.9994 15.8347 9.99905 15.8345C9.99898 15.8345 9.99891 15.8345 9.99885 15.8344C9.99883 15.8344 9.9988 15.8343 9.99877 15.8342Z"
          strokeWidth="1.67"
        />
      </g>
    </svg>
  );
};
